import { render, staticRenderFns } from "./confiTionDialog.vue?vue&type=template&id=0133926d&scoped=true&"
import script from "./confiTionDialog.vue?vue&type=script&lang=js&"
export * from "./confiTionDialog.vue?vue&type=script&lang=js&"
import style1 from "./confiTionDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133926d",
  null
  
)

export default component.exports